import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import "../../../Styles/style.css";
import AdminApiModule from "../../../components/AdminApi/Api/api";
import { Alert, InputAdornment, Snackbar, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const stylesCss = {
  inputBox: {
    width: "100%",
    marginBottom: "10px",
  },
  gridStyle: {
    width: "80%",
    margin: "auto",
  },
  paddingInnerGrids: {
    paddingRight: "10px",
    paddingLeft: "10px",
    paddingTop: "10px",
  },
};

const AddUser = () => {
  const [state, setState] = useState({
    userName: "",
    password: "",
    phoneNumber: "",
    roleChosenId: "",
    rolesList: [],
    toast: {
      open: false,
      msg: "",
      duration: 5000,
      type: "",
    },
    isFormValid: false,
    isRegistering: false,
    isEditDetailsExists: false,
    doesUserExists: false,
  });

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reduxState = useSelector((state) => state.userReducer);

  useEffect(() => {
    getAllRolesExists();

    console.log("hey man", reduxState);

    const editUserId = searchParams.get("edit");

    console.log(editUserId, "edit user id");

    if (editUserId != null) {
      getUserDetails(editUserId);
    }
  }, []);

  const getAllRolesExists = () => {
    new AdminApiModule()
      .getAllAvailableRoles()
      .then((res) => {
        setState((prev) => ({
          ...prev,
          rolesList: res.data,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getUserObjIdForEdit = () => {
    return searchParams.get("edit");
  };

  const getUserDetails = (editUserId) => {
    const payload = {
      user_obj_id: editUserId,
    };
    setState((prev) => ({
      ...prev,
      isEditDetailsExists: true,
    }));

    new AdminApiModule()
      .getAllUsers(payload)
      .then((res) => {
        if (res?.data?.length) {
          setState((prev) => ({
            ...prev,
            doesUserExists: true,
          }));

          updateUserDetails(res?.data?.[0]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateUserDetails = (userDetails) => {
    setState((prev) => ({
      ...prev,
      userName: userDetails?.user_name,
      password: userDetails?.password,
      phoneNumber: userDetails?.phone_number,
      roleChosenId: userDetails?.role_id,
    }));
  };

  const showDialog = (open, type, msg) => {
    setState((prev) => ({
      ...prev,
      toast: {
        open: open,
        msg: msg,
        duration: 5000,
        type: type,
      },
    }));
  };

  const closeDialog = (open = false) => {
    setState((prev) => ({
      ...prev,
      toast: {
        open: open,
        msg: "",
        duration: 5000,
        type: "",
      },
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRegister = () => {
    const { userName, password, phoneNumber, roleChosenId } = state;

    if (!userName) {
      setState((prev) => ({
        ...prev,
        isFormValid: true,
      }));

      showDialog(true, "error", "Please fill in all required details");
      return;
    }

    setState((prev) => ({
      ...prev,
      isRegistering: true,
    }));

    const payload = {
      user_name: userName,
      password: password,
      country_code: "+91",
      phone_number: phoneNumber,
      role_id: roleChosenId,
    };

    if (state.isEditDetailsExists) {
      payload.user_obj_id = getUserObjIdForEdit();

      payload["user_name"] = userName || "";
      payload["password"] = password || "";
      payload["phone_number"] = phoneNumber || "";
      payload["role_id"] = roleChosenId || "";

      new AdminApiModule()
        .adminUpdateRole(payload)
        .then((res) => {
          showDialog(true, "success", "User updated successfully");

          setState((prev) => ({
            ...prev,
            isRegistering: false,
          }));

          navigate("/users");
        })
        .catch((err) => {
          console.log(err);
          showDialog(true, "error", err?.response?.data?.message);
          setState((prev) => ({
            ...prev,
            isRegistering: false,
          }));
        });

      return;
    }

    new AdminApiModule()
      .adminCreateUser(payload)
      .then((res) => {
        showDialog(true, "success", "User Created successfully");

        handleResetValues();
        navigate("/users");
      })
      .catch((err) => {
        console.log(err);
        setState((prev) => ({
          ...prev,
          isRegistering: false,
        }));
        showDialog(true, "error", err?.response?.data?.message);
      });
  };

  const handleResetValues = () => {
    setState((prev) => ({
      ...prev,
      isRegistering: false,
      userName: "",
      password: "",
      phoneNumber: "",
      roleChosenId: "",
    }));
  };

  const {
    toast: snackBarValues,
    isFormValid,
    userName,
    password,
    phoneNumber,
    roleChosenId,
    rolesList,
    isRegistering,
    isEditDetailsExists,
    doesUserExists,
  } = state;

  if (isEditDetailsExists && !doesUserExists) {
    return <>Page not found !!!</>;
  }

  return (
    <div>
      {snackBarValues.open && (
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={snackBarValues.open}
          autoHideDuration={snackBarValues.duration}
          onClose={closeDialog}
        >
          <Alert
            onClose={closeDialog}
            severity={snackBarValues.type}
            sx={{ width: "100%" }}
          >
            {snackBarValues.msg}
          </Alert>
        </Snackbar>
      )}
      <h2 className="text-align-center">
        {isEditDetailsExists ? "Update User" : "Add User"}
      </h2>
      <Item>
        <Grid container>
          <Grid item style={stylesCss.paddingInnerGrids} md={6}>
            <TextField
              id="demo-helper-text-misaligned"
              label="User Name"
              style={stylesCss.inputBox}
              name="userName"
              value={userName}
              onChange={handleChange}
              error={isFormValid && !userName}
            />
          </Grid>

          <Grid item style={stylesCss.paddingInnerGrids} md={6}>
            <TextField
              id="demo-helper-text-misaligned"
              label="Password"
              style={stylesCss.inputBox}
              name="password"
              value={password}
              onChange={handleChange}
              error={isFormValid && !password}
              type="password"
            />
          </Grid>

          <Grid item style={stylesCss.paddingInnerGrids} md={6}>
            <TextField
              id="demo-helper-text-misaligned"
              label="Mobile Number"
              name="phoneNumber"
              onChange={handleChange}
              style={stylesCss.inputBox}
              error={isFormValid && !phoneNumber}
              value={phoneNumber}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography>+91</Typography>
                  </InputAdornment>
                ),
              }}
              inputProps={{ maxLength: 10 }}
            />
          </Grid>

          <Grid item md={6} style={stylesCss.paddingInnerGrids}>
            <FormControl
              md={6}
              style={stylesCss.inputBox}
              sx={{ minWidth: 120 }}
            >
              <InputLabel id="demo-simple-select-helper-label">
                Choose Role
              </InputLabel>
              <Select
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                label="Choose Role"
                name="roleChosenId"
                onChange={handleChange}
                error={isFormValid && !roleChosenId}
                value={roleChosenId}
              >
                {rolesList?.map((ite) => {
                  return (
                    <MenuItem key={ite._id} value={ite._id}>
                      {ite.role_name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid style={stylesCss.paddingInnerGrids} item md={6}>
            <Button
              variant="contained"
              onClick={handleRegister}
              disabled={isRegistering}
            >
              {isEditDetailsExists ? "Update " : "Save"}
            </Button>
          </Grid>
        </Grid>
      </Item>
    </div>
  );
};

export default AddUser;
